import React, { useEffect, useRef, useState } from "react";
import validation from "../../../utilities/validation";
import * as utilities from "../../../utilities/utils";
import {
  EMAILREGEX,
  EMAIL_PLACEHOLDER,
  NUMBER_FORMAT_REGEX,
  PHONE_PLACEHOLDER,
} from "../../../App.config";
import DropdownComponent from "../../../containers/Dropdown";

const ManagerDetailModalComponent = (props) => {
  const initialState = {
    location: {
      value: [],
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      positionCount: 1,
    },
    jobTitle: {
      value: [],
      error: "",
      validation: {},
      ref: useRef(),
      validation: {
        required: true,
      },
      positionCount: 2,
    },
    managerName: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      positionCount: 3,
    },
    managerPhone: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Phone",
      positionCount: 4,
    },
    managerEmail: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: EMAILREGEX,
        type: "Email",
      },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Email",
      positionCount: 5,
    },
    isSubmitOnce: { value: false },
  };

  const [state, setState] = useState(initialState);

  // Set to inital state after component change
  useEffect(() => {

    return () => {
      setState((state) => {
        return {
          ...initialState,
        };
      });
    };
  }, []);

  const handleChanges = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    setState((state) => {
      return {
        ...state,
        [name]: updatedObj,
      };
    });
  };

  const onDropDownChange = (event) => {
    let { name, value } = event;

    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    setState((state) => {
      return { ...state, [name]: updatedObj };
    });
  };

  const handlePhoneNumber = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((previousState) => {
      return {
        ...previousState,
        [name]: utilities.convertIntoObject(
          utilities.normalizeTelePhoneNumber(
            updatedObj.value,
            previousState[name][value]
          ),
          previousState[name]
        ),
      };
    });
  };

  const FormValidation = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        let validatedObj = validation(state[property], props.context);

        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const isFormValid = () => {
    let isValid = true;
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (state[property]?.error.length > 0) {
          isValid = false;
        }
      }
    }
    return isValid;
  };

  const onSubmit = () => {
    setState((state) => {
      return {
        ...state,
        isSubmitOnce: utilities.convertIntoObject(true),
      };
    });

    FormValidation();

    if (isFormValid()) {
      let managerInfo = {
        locationID_FK: utilities.extractFirstValueOfArray(state.location.value),
        jobID_FK: utilities
          .extractFirstValueOfArray(state.jobTitle.value)
          ?.toString(),
        primaryName: state.managerName.value,
        primaryPhone: state.managerPhone.value,
        primaryFax: null,
        primaryTitle: null,
        primaryEmail: state.managerEmail.value,
        contactType: 0,
      };
      props.addNewManager(managerInfo);
    } else {
      ///How to get First error in particular step
      let errorObject = [];

      for (const property in state) {
        if (state[property].error)
          errorObject.push({
            name: property,
            label: state[property].label,
            error: state[property].error,
            positionCount: state[property].positionCount,
          });
      }
      errorObject.sort(function (a, b) {
        return a.positionCount - b.positionCount;
      });

      //Setting focus on first error field
       //Setting focus on first error field
       if (state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus) {
        state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus();
      } else {
        state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.setFocus();
      }
    }
  };

  return (
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {props.context.t(
              "STD-Employer-Statement.form.Employer-Details.label.heading.ManagerModalHeading"
            )}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => props.closeRemoveModal()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <span>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                <div className="form-group">
                  <label htmlFor="">
                    {props.context.t(
                      "STD-Employer-Statement.form.dropdown.text.Division/Location"
                    )}
                    <span size="5" className="error-star">
                      *
                    </span>
                  </label>
                  {props.location && (
                    <DropdownComponent
                      name="location"
                      options={props.location}
                      isMultiSelect={false}
                      option_key="coLocationID_PK"
                      option_display="locationName"
                      onChange={onDropDownChange}
                      values={state.location.value}
                      simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                      selectAllText="Select All Options"
                      isSearchOption={true}
                      searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      ref={state.location.ref}
                    />
                  )}
                  {state.location?.error && (
                    <span className="error">{state.location.error}</span>
                  )}
                </div>
              </div>
              
              <div className="col-10 col-sm-11 col-md-11 col-lg-6">
              <div className="form-group">
                <label htmlFor="">
                  {props.context.t(
                    "STD-Employer-Statement.form.Employee-Details.label.text.Job"
                  )}
                  <span size="5" className="error-star">
                    *
                  </span>
                </label>
                <div className="Custom-select">
                  <DropdownComponent
                    name="jobTitle"
                    options={props.job ? props.job : []}
                    isMultiSelect={false}
                    option_key="jobID_PK"
                    option_display="jobName"
                    onChange={onDropDownChange}
                    values={state.jobTitle.value}
                    simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                    selectAllText="Select All Options"
                    isSearchOption={true}
                    searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                    ref={state.jobTitle.ref}
                  />
                  {state.jobTitle?.error && (
                    <span className="error">{state.jobTitle.error}</span>
                  )}
                </div>
              </div>
            </div>   
            
              
            </div>

            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="form-group">
                  <label htmlFor="">
                    {props.context.t(
                      "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Name-File-Contact"
                    )}
                    <span size="5" className="error-star">
                      *
                    </span>
                  </label>
                  <div className="form-group">
                    <input
                      placeholder={props.context.t(
                        "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      )}
                      className="form-control"
                      name="managerName"
                      ref={state.managerName.ref}
                      value={state.managerName.value}
                      onChange={handleChanges}
                    />
                    {state.managerName?.error && (
                      <span className="error">{state.managerName.error}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                <div className="form-group">
                  <label htmlFor="">
                    {props.context.t(
                      "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Phone"
                    )}
                    <span size="5" className="error-star">
                      *
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={PHONE_PLACEHOLDER}
                    maxLength="14"
                    name="managerPhone"
                    value={state.managerPhone.value}
                    ref={state.managerPhone.ref}
                    onChange={handlePhoneNumber}
                  />
                  {state.managerPhone?.error && (
                    <span className="error">{state.managerPhone.error}</span>
                  )}
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                <div className="form-group">
                  <label htmlFor="">
                    {props.context.t(
                      "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Email"
                    )}
                    <span size="5" className="error-star">
                      *
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={EMAIL_PLACEHOLDER}
                    name="managerEmail"
                    value={state.managerEmail.value}
                    ref={state.managerEmail.ref}
                    onChange={handleChanges}
                  />
                  {state.managerEmail?.error && (
                    <span className="error">{state.managerEmail.error}</span>
                  )}
                </div>
              </div>
            </div>
          </span>
        </div>
        <div className="modal-footer">
          <button onClick={onSubmit} type="button" className="btn btn-primary">
            {props.context.t("STD-Employer-Statement.form.Common.Submit")}
          </button>
        </div>
      </div>
    </div>
  );
};
export default ManagerDetailModalComponent;
